export class CuttingPaymentData {
  orderId: number;
  amount: number;

  constructor(psbPaymentData?: CuttingPaymentData | any) {
    psbPaymentData = psbPaymentData || {};
    this.orderId = psbPaymentData.orderId || 0;
    this.amount = psbPaymentData.amount || 0;
  }
}
